import { SVGProps } from 'react';

const Tangent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.59 5.41 5.41 15.59M12 22s-4-9-1.5-11.5S22 12 22 12m-3-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Tangent;
